import React from "react";
import { HexCheckIconSmall } from "@icons/hexpert/HEXCheckIconSmall";
import './HexCheckbox.scss';

type THexCheckbox = {
  label?: string;
  name?: string;
  value?: string;
  selected?: boolean;
  onChange?: () => void;
};

export const HexCheckbox = ({
  label,
  name,
  value,
  selected,
  onChange,
}: THexCheckbox) => {
  return (
    <div className={"c-hex-checkbox-conatiner"}>
      <input
        type={"checkbox"}
        name={name}
        value={value}
        checked={selected}
        onChange={onChange}
        className={"c-hex-checkbox-input"}
      />
      <span className={"c-hex-checkbox-check-container"}>
        <HexCheckIconSmall />
      </span>
      <label htmlFor={name} className={"c-hex-checkbox-label"}>
        {label}
      </label>
    </div>
  );
};
